var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M5.33268 5.33337H26.666C28.1327 5.33337 29.3327 6.53337 29.3327 8.00004V24C29.3327 25.4667 28.1327 26.6667 26.666 26.6667H5.33268C3.86602 26.6667 2.66602 25.4667 2.66602 24V8.00004C2.66602 6.53337 3.86602 5.33337 5.33268 5.33337Z","stroke":"#587EEC","strokeWidth":"2.57143","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M29.3327 8L15.9993 17.3333L2.66602 8","stroke":"#587EEC","strokeWidth":"2.57143","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Mail.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Mail;

Mail.default = Mail;
